import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type AxiosResponse } from 'axios';
import { type Report } from 'types/files';

export type { Report } from 'types/files';

export type FileServiceTypes = {
  getReportsByPatient: (patientId: string) => Promise<AxiosResponse<Report[]>>;
  getReportsByAppointment: (appointmentId: string) => Promise<AxiosResponse<Report[]>>;
};

const FILES_URL = `${BASE_URL}files`;

export const FileService: FileServiceTypes = {
  getReportsByPatient: async patientId =>
    service.get(`${FILES_URL}/reports/${patientId}/insurance`),
  getReportsByAppointment: async appointmentId =>
    service.get(`${FILES_URL}/reports/appointments/${appointmentId}/insurance`),
};
